export const tooltip = () => ({
  open: false,
});
